
// Global Variables
  	const viewPort = window.innerWidth;

// The getRandomColor function gets random numbers to create random rgb colors, and returns rgb colors
function getRandomColor(red, green, blue, red2, green2, blue2) {
	const _red = red
	const _green = green
	const _blue = blue
	const _red2 = red2
	const _green2 = green2
	const _blue2 = blue2
	const rgb1 = `rgb(${_red}, ${_green}, ${_blue})`;
	const rgb2 = `rgb(${_red2}, ${_green2},${_blue2})`;
  
    if (viewPort > 767) {
      const gradient = `linear-gradient(to right, ${rgb1}, ${rgb2})`;
	  document.querySelector('.banner_div').style.backgroundImage = gradient;
	  return gradient;
    } else {
      const gradient = `linear-gradient(to bottom right, ${rgb1}, ${rgb2})`;
	  document.querySelector('.banner_div').style.backgroundImage = gradient;
	  return gradient;
    }
}

// Find the opposite color value of the middle of the Random Gradient, and changes banner solid color button background color and text
function getOppositeRandomColor(red, green, blue, red2, green2, blue2) {
	const opposite_red = 255 - ((red + red2) /2);
	const opposite_green = 255 - ((green + green2) /2);
	const opposite_blue = 255 - ((blue + blue2) /2);
	const opposite_rgb = `rgb(${opposite_red}, ${opposite_green},${opposite_blue})`;
  	const rgbAvg = (opposite_red + opposite_green + opposite_blue) / 3;
  
	document.querySelector('.action_button.solid').style.backgroundColor = opposite_rgb;
        
    if (rgbAvg < 170) {
        document.querySelector('a.action_button.solid span').style.color = 'white';
    } else {
        document.querySelector('a.action_button.solid span').style.color = 'black';
    }
}


// The backgroundGradient funtion loads new background color
function backgroundGradient() {
	const red = Math.floor((Math.random() * 255) + 1 );
	const green = Math.floor((Math.random() * 255) + 1 );
	const blue = Math.floor((Math.random() * 255) + 1 );
	const red2 = Math.floor((Math.random() * 255) + 1 );
	const green2 = Math.floor((Math.random() * 255) + 1 );
	const blue2 = Math.floor((Math.random() * 255) + 1 );
  
	getRandomColor(red, green, blue, red2, green2, blue2);
	getOppositeRandomColor(red, green, blue, red2, green2, blue2);
    

  
	
}
window.setInterval(backgroundGradient, 3000);

window.onscroll = function backToTop(){
  var scrollPosY = window.pageYOffset | document.body.scrollTop;
  const button = document.querySelector('.to-top');
  if(scrollPosY > 700) {
  	button.style.display = 'block';
  } else if(scrollPosY <= 700) {
  	button.style.display = 'none';
  }
    
}

